import configuration from 'src/configuration'

const DEMO_BUYER_EMAILS = ['demo-cliente-mc@yopmail.com']
const DEMO_SUPPLIER_EMAILS = [
  'demo-fornitore-mc@yopmail.com',
  'fornitore-demo-1@yopmail.com',
  'fornitore-demo-2@yopmail.com',
  'fornitore-demo-3@yopmail.com'
]

/** true su build/env PRE o login demo multi-carta */
export const isPreDemoEnvironment = (user) => {
  if (configuration.environment === 'pre') {
    return true
  }
  if (!user?.email) {
    return false
  }
  return DEMO_BUYER_EMAILS.includes(user.email) || DEMO_SUPPLIER_EMAILS.includes(user.email)
}

export const isPreDemoBuyerEnvironment = (user) => {
  if (configuration.environment === 'pre') {
    return true
  }
  return Boolean(user?.email && DEMO_BUYER_EMAILS.includes(user.email))
}
